<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <consultaprodutos v-bind:idtabela="vidtabela" v-bind:showprtabela="vshowprtabela" v-bind:filtrotipo="tipopropesquisa"></consultaprodutos>
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-8 col-md-2 col-lg-2">
                                <label for="edconteudopesq">Código:</label>
                                <input id="edconteudopesq" type="number" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>                            
							<div class="col-sm-12 col-md-9 col-lg-3">
								<span class="lblselect2">Filial origem:</span>
								<select id="cbfilialorigempesq" data-placeholder="Selecione uma filial" v-model="pidfilialorigem" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-9 col-lg-3">
								<span class="lblselect2">Filial destino:</span>
								<select id="cbfilialdestinopesq" data-placeholder="Selecione uma filial" v-model="pidfilialdestino" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo" @change="mtdlimpar_listagem()">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>                                                        
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbsituacaopesq">Situação:</label>
                                <select name="cbsituacaopesq" class="form-control form-control-sm" id="cbsituacaopesq" v-model="psttransferencia" @change="mtdlimpar_listagem()">
                                    <option value="0">Em digitação</option>
                                    <option value="1">Efetivada</option>
                                    <option value="2">Todas</option>
                                </select>
                            </div>                            
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lsttransferencias"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ mtdformatarzeros(item.row.id, 8) }}
                                    </template>
                                    <template slot="slot_sttransferencia" slot-scope="item">
                                        <span v-if="parseInt(item.row.sttransferencia) === 0" class="badge badge-pill badge-primary" style="background: #646dd4;">Em edição</span>
                                        <span v-else class="badge badge-pill badge-primary" style="background: #5a956a;">Efetivada</span>                                        
                                    </template>                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdmostrarmenu(item.row)" style="width: 35px;">
											<i class="fa fa-navicon"></i>
										</button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lsttransferencias.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
							<div class="col-sm-12 col-md-10 col-lg-3">
								<span class="lblselect2">*Filial origem:</span>
								<select id="cbfilialorigem" data-placeholder="Selecione uma filial" v-model="vidfilialorigem" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-10 col-lg-3">
								<span class="lblselect2">*Filial destino:</span>
								<select id="cbfilialdestino" data-placeholder="Selecione uma filial" v-model="vidfilialdestino" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
                            <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2" style="padding-top: 21px;">                            
                                <div class="custom-control custom-switch border rounded" style="margin-top: -2px;padding: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cblancarauto" v-model="lancarauto" v-bind:disabled="ativadesativa">
                                    <label class="custom-control-label" for="cblancarauto" id="lbllancarauto" style="margin-left: 40px;">Lançar unitário</label>
                                </div>
                            </div>  
							<div class="col-sm-12 col-md-3 col-lg-2">
								<label for="eddtemissao">*Dt. Emissão:</label>
								<div class="input-group">
									<date-picker id="eddtemissao" v-model="vdtemissao" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>                            
                        </div>
                        <div class="row" style="margin-top: 15px;">
							<div class="col-md-12">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#dvitens">Ítens da transferência</a>
                                    </li>
								    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvobservacoes">Observações</a>
                                    </li>																		
                                </ul>
								<div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
									<div id="dvitens" class="container-fluid tab-pane active">
										<div v-show="parseInt(opcrud) < 3" class="row">
                                            <div class="col-sm-12 col-md-3 col-lg-2">
                                                <label for="edidprodutoedicao">*Produto:</label>
                                                <div class="input-group" style="z-index: 1;">
                                                    <input type="text" class="form-control form-control-sm" id="edidprodutoedicao" v-bind:disabled="parseInt(opcrud) === 3" v-model="vcoddigedicao" maxlength="20" v-on:blur="mtdlocalizarproduto(vcoddigedicao)" v-on:keyup.13="mtdlocalizarproduto(vcoddigedicao)" style="text-transform: uppercase;">
                                                    <div class="input-group-append">
                                                        <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarproduto()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-7 col-lg-6">
                                                <label for="eddescricaoprodutoedicao">Descrição do produto:</label>
                                                <div class="input-group" style="z-index: 1;">
                                                    <input type="text" class="form-control form-control-sm" id="eddescricaoprodutoedicao" v-model="vdescricaoprodutoedicao" maxlength="100" style="font-weight: bold;" v-bind:disabled="vedicaodescpro" v-on:blur="mtddesabilitaedicaodescpro()">
                                                    <div class="input-group-append">
                                                        <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdhabilitaedicaodescpro()" title="Alterar descrição"><i class="fa fa-edit" style="padding-top: 3px;"></i></a>
                                                    </div>
                                                </div>									
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edundprodutoedicao">Und:</label>
                                                <input type="text" class="form-control form-control-sm" id="edundprodutoedicao" v-model="vundprodutoedicao" data-bv-group=".group" maxlength="2" disabled style="font-weight: bold;"/>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edqtditemedicao">*Quantidade:</label>
                                                <money type="text" class="form-control form-control-sm" id="edqtditemedicao" v-model="vqtditemedicao" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-4">
                                                <span class="lblselect2">*Estoque origem:</span>
                                                <select id="cbestoqueorigemedicao" data-placeholder="Selecione estoque origem" v-model="videstoqueorigemedicao" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-4">
                                                <span class="lblselect2">*Estoque destino:</span>
                                                <select id="cbestoquedestinoedicao" data-placeholder="Selecione estoque destino" v-model="videstoquedestinoedicao" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div> 
                                            <div class="col-md-2">
                                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdincluiritem()" style="margin-top: 20px;"><i class="fa fa-plus"></i> Incluir</button>
                                            </div>
                                            <div class="col-md-2">
                                                <button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdrotinaestoque()" style="margin-top: 20px;"><i class="fa fa-exchange"></i> Alterar estoque</button>
                                            </div>                                            
										</div>
                                        <div class="row">
                                            <div class="col-md-12" style="margin-top: 10px;">
                                                <vue-bootstrap4-table ref="reflstitens"
                                                        :rows="lstitenstransf"
                                                        :columns="columnsitens"
                                                        :config="configitens"
                                                        :classes="classes">
                                                    <template slot="empty-results">
                                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                                    </template>
                                                    <!-- ícones de ordenação da table -->
                                                    <template slot="sort-asc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                                    </template>
                                                    <template slot="sort-desc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                                    </template>
                                                    <template slot="no-sort-icon">
                                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                                    </template>                                    
                                                    <!--  -->                                                    
                                                    <template slot="opcoes" slot-scope="item">
                                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluiritem(item.row)" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-trash"></i></button>
                                                    </template>
                                                    <template slot="slot_qtditem" slot-scope="item">
                                                        <span @click.prevent="mtdalterarqtd(item.row, false, 1)"><i class="op-qtd op-qtd-ret fa fa-minus-circle"></i></span>
                                                        <span>{{ item.row.qtditem }}</span>
                                                        <span @click.prevent="mtdalterarqtd(item.row, true, 1)"><i class="op-qtd op-qtd-acres fa fa-plus-circle"></i></span>
                                                    </template>
                                                </vue-bootstrap4-table>
                                            </div>
										</div>
									</div>
									<div id="dvobservacoes" class="container-fluid tab-pane">
										<div class="row">
                                            <div class="col-sm-12">
                                                <textarea class="form-control center" rows="5" id="txtobservacoes" v-model="vobservacoes" v-bind:disabled="ativadesativa"></textarea>
                                            </div>											
										</div>
									</div>                                    
								</div>                                                                        
							</div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

		<div class="modal fade" id="mdmenutransf">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<ul class="list-group" style="cursor: pointer;">
								<li class="list-group-item font-weight-bold text-center active" style="font-size: 18px;">{{ mtdformatarzeros(transfmenu.id, 8) }}</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdalterar(transfmenu)" data-dismiss="modal"><i class="fa fa-edit"></i> ALTERAR</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdexcluir(transfmenu)" data-dismiss="modal"><i class="fa fa-trash"></i> EXCLUIR</li>
								
                                <!--Luiz Trindade - Botão de imprimir com dropdown-->
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.stop @click.prevent="alternadetalheimpressao">
                                    <i class="fa fa-print"></i> 
                                    IMPRIMIR
                                    <div v-show="mostrarDetalheImpressao" style="padding-left: 0; padding-right: 0; padding-top: 20px;" class="dropdown-item" @click.stop>
                                        <label for="cbdetalhadaitem" class="mb-0">Exibir custos:</label>
                                        <select name="cbdetalhadaitem" class="form-control form-control-sm" id="cbdetalhadaitem" v-model="detalheitem">
                                            <option value="0">Não</option>
                                            <option value="1">Sim</option>
                                        </select>
                                        <div class="mt-2">
                                            <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="confirmarImpressao(transfmenu.id)"><i class="fa fa-print"></i> Confirmar</button>
                                        </div>
                                    </div>
                                </li>
                                <!-- <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdimprimirtransferencia(transfmenu.id)" data-dismiss="modal"><i class="fa fa-print"></i>
                                    IMPRIMIR
                                </li>								 -->
								
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdefetivar(transfmenu)" data-dismiss="modal"><i class="fa fa-check"></i> EFETIVAR</li>
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtrotinanf(transfmenu)" data-dismiss="modal"><i class="fa fa-qrcode"></i> GERAR NF-e</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12 text-center">
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Cancelar</button>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div> 

        <!-- Alterar estoque --> 
        <div class="modal fade" id="mdalterarestoque">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-exchange" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Alteração de estoque</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <label for="cbatribuir">Atribuir em:</label>
                                <select name="cbatribuir" class="form-control form-control-sm" id="cbatribuir" v-model="vatribuirestoque">
                                    <option value="0">Origem</option>
                                    <option value="1">Destino</option>
                                </select>
                            </div>                                            
                            <div class="col-md-12" id="dvclasseatribuir">
                                <span class="lblselect2">Estoque:</span>
                                <select id="cbestoquealterar" data-placeholder="Selecione uma opção"
                                    v-model="videstoquealterar"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdatribuirestoque()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>                          
                </div>
            </div>
        </div> 

        <!-- Informar cliente NF-e --> 
        <div class="modal fade" id="mdinformacliente">
            <div class="modal-dialog modal-md modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-qrcode" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Geração de NF-e</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
							<div class="col-12">
								<span class="lblselect2">Cliente:</span>
								<select id="cbclientenf" data-placeholder="Selecione um cliente" v-model="idclientenf" data-allow-clear="true" style="width:100%;">
								</select>
							</div>                            
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdgerarnf()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>                          
                </div>
            </div>
        </div>                                     
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import ConsultarProdutos from '../components/cmpconsultarprodutos.vue'
    import util from '../utilitarios/util.js'

    export default {
        name: 'cadtransferenciasfiliais',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb,
            'consultaprodutos'  : ConsultarProdutos
        },
        data: function() {
            return {
                utodasfiliais       : this.$store.state.usuario.todasfiliais,
                //variáveis para a consulta de produtos
                vshowprtabela		: false,
                vidtabela           : null,
                tipopropesquisa     : '',

                transfmenu          : [],

                lsttransferencias   : [],
                pconteudo           : '',
				pfiltroperiodo      : 1,
				pdtini       		: util.DataAtual(true),
                pdtfim       		: util.DataAtual(true),
                pidfilialorigem     : null,
                pidfilialdestino    : null,
                psttransferencia    : 2,				                                
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,

                //variáveis do crud
                opcrud              :  0,
                lstitenstransf      : [],
                vid                 : '',
                vidfilialorigem     : null,
                vidfilialdestino    : null,
                vdtemissao          : util.DataAtual(true, false),
                vobservacoes        : '',
                vtotalcusto         : 0,
                vtotalvenda         : 0,
                lancarauto          : false,

                vatribuirestoque    : 0, //0 - Origem, 1 - Destino
                videstoquealterar   : null,

                //variáveis de edição dos ítens
                vitem                   : 0,
                vcoddigedicao           : '',
                vdescricaoprodutoedicao : '',
                vedicaodescpro			: true,
                vundprodutoedicao       : '',
                vqtditemedicao          : 1,
                vfracionadoedicao       : 0,
                prcustoedicao           : 0,
                vlunitarioedicao        : 0,
                videstoqueorigemedicao  : null,
                videstoquedestinoedicao : null,

                //Luiz Trindade - Custo de itens variável
                vcustoitens             : 0,

                //variavel de impressão detalhada
				mostrarDetalheImpressao	: false,
				detalheitem				: 0,

                //variável para habilitação dos campos
                ativadesativa           : true,

                //variavel da nf
                transferencianf         : [],

                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                },				
				money				: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'TRANSFERÊNCIAS ENTRE FILIAIS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Situação",
                        name: "sttransferencia",
                        sort: true,
                        slot_name: "slot_sttransferencia",
                        row_classes: "def-col-sttransferencia",
                    },                    
                    {
                        label: "Origem",
                        name: "fantasiafilialorigem",
                        sort: true,
                        slot_name: "slot_filialorigem",
                        row_classes: "def-col-filialorigem",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                    },
                    {
                        label: "Destino",
                        name: "fantasiafilialdestino",
                        sort: true,
                        slot_name: "slot_filialdestino",
                        row_classes: "def-col-filialdestino",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                    },
                    {
                        label: "Dt. Emissão",
                        name: "dtemissao",
                        sort: true,
                        slot_name: "slot_dtemissao",
                        row_classes: "def-col-dtemissao",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                    },
                    {
                        label: "Dt. efetivação",
                        name: "dtefetivacao",
                        sort: true,
                        slot_name: "slot_dtefetivacao",
                        row_classes: "def-col-dtefetivacao",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",                        
                    }
                ],
                columnsitens: [
                    {
                        label: '',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-item",
                        sort: false
                    },
                    {
                        label: "Item",
                        name: "item",
                        sort: true,
                        slot_name: "slot_item",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Código",
                        name: "coddig",
                        sort: true,
                        slot_name: "slot_coddig",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descproduto",
                        sort: true,
                        slot_name: "slot_descpro",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                    },
                    {
                        label: "Estoque origem",
                        name: "descestoqueorigem",
                        sort: true,
                        slot_name: "slot_descricao_estoque_origem",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                    },
                    {
                        label: "Estoque destino",
                        name: "descestoquedestino",
                        sort: true,
                        slot_name: "slot_descricao_estoque_destino",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                    },
                    {
                        label: "Qtd",
                        name: "qtditem",
                        sort: true,
                        slot_name: "slot_qtditem",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-qtd-item",
                    },
                    {
                        label: "Und",
                        name: "unditem",
                        sort: true,
                        slot_name: "slot_unditem",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                    }
                ],                
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                configitens: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    checkbox_rows: true,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },                
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            //Luiz Trindade - Métodos de impressão
            // mtdimprimircustos(param){
            //     this.vcustoitens = 1;
            //     this.mtdimprimirtransferencia(param);
            // },
            // mtdimprimirsemcustos(param){
            //     this.vcustoitens = 0;
            //     this.mtdimprimirtransferencia(param);
            // },
            alternadetalheimpressao() {
				this.mostrarDetalheImpressao = !this.mostrarDetalheImpressao;
			},
            confirmarImpressao(param) {
				// this.mtdimpressao(0);
                if (this.detalheitem == 0){
                    this.vcustoitens = 0;
                    this.mtdimprimirtransferencia(param);
                }
                else{
                    this.vcustoitens = 1;
                    this.mtdimprimirtransferencia(param);
                }

				this.mostrarDetalheImpressao = false; 
				// $('.dropdown-toggle').dropdown('hide'); 
				this.detalheitem = 0;
			},


			mtdmostrarmenu(transferencia){				
				this.transfmenu = transferencia;
				$('#mdmenutransf').modal('show');
			},             
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},             
            mtdcarregaestoquepadraofilial(idfilial, select2, vself){
                let loader      = vself.$loading.show();
                let filtro      = ' and f.codfil='+idfilial;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'diretoriocertificados', valor : vself.$store.state.configpaths.pathcertificados+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfiliais.php');
                retorno.then(function (response) {
                    loader.hide();
                    var defestoque  = new Option(response.data[0].descestoque, response.data[0].idestoque, true, true);
                    $(select2).append(defestoque).trigger('change'); 
                }).catch(function (response) {
                    loader.hide();
                });
            },        
            mtdconsultarproduto(){
				if (parseInt(this.opcrud) < 3){
					let payload = {
						abrirtela    : true			
					};
					this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);
					let payloadx = {
						idproduto    : null			
					};
					this.$store.commit('PRODUTO_RETORNO_CHANGE',payloadx);                
				}
			},            
			mtdlimparedicaoitem(){
				this.vedicaodescpro				= true;
				this.vidprodutoedicao    		= '';
				this.vcoddigedicao				= '';
				this.vdescricaoprodutoedicao 	= '';
				this.vundprodutoedicao			= '';
				this.vqtditemedicao				= 1;
				this.vfracionadoedicao			= 0;
			},            
			mtdhabilitaedicaodescpro(){
                if (parseInt(this.opcrud) < 3){
                    this.vedicaodescpro = false;
                    setTimeout(function(){
                        $('#eddescricaoprodutoedicao').focus();
                    }, 300); 				
                }
            },
			mtddesabilitaedicaodescpro(){
				this.vedicaodescpro = true;
			},                        
            mtdlocalizarproduto(coddig){
              console.log('aqui')
				if (coddig !== '' && coddig !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ''},
						{parametro: 'coddig',           valor : coddig},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let produto = response.data[0];							
							vself.vidprodutoedicao			= produto.id;
							vself.vdescricaoprodutoedicao 	= produto.descricao;
							vself.vundprodutoedicao			= produto.und;
                            vself.vfracionadoedicao			= produto.fracionado;
                            vself.prcustoedicao             = produto.prcusto;
                            vself.vlunitarioedicao          = util.mtdcarregaprecotabela(produto.tabelas, 1);
                            
                            if(vself.lancarauto){
                                if (vself.vidfilialorigem === null){                    
                                    vself.$toastr.w('Filial de origem deve ser informada!', 'Informação!');
                                    $('#cbfilialorigem').focus();
                                    return;
                                }
                                if (vself.vidfilialdestino === null){                    
                                    vself.$toastr.w('Filial de destino deve ser informada!', 'Informação!');
                                    $('#cbfilialdestino').focus();
                                    return;
                                }                
                                if (vself.vcoddigedicao === ''){                    
                                    vself.$toastr.w('Código do produto deve ser informado!', 'Informação!');
                                    $('#edidprodutoedicao').focus();
                                    return;
                                }
                                if (vself.vdescricaoprodutoedicao === ''){                    
                                    vself.$toastr.w('Descrição do produto deve ser informada!', 'Informação!');
                                    vself.mtdhabilitaedicaodescpro();
                                    return;
                                }                                
                                if (parseFloat(vself.vqtditemedicao) <= 0){                    
                                    vself.$toastr.w('Quantidade inválida!', 'Informação!');
                                    $('#edqtditemedicao').focus();
                                    return;
                                }                
                                if (vself.videstoqueorigemedicao === null){                    
                                    vself.$toastr.w('Estoque de origem deve ser informado!', 'Informação!');
                                    $('#cbestoqueorigemedicao').focus();
                                    return;
                                }
                                if (vself.videstoquedestinoedicao === null){                    
                                    vself.$toastr.w('Estoque de destino deve ser informado!', 'Informação!');
                                    $('#cbestoquedestinoedicao').focus();
                                    return;
                                }
                                if (vself.videstoqueorigemedicao === vself.videstoquedestinoedicao){                    
                                    vself.$toastr.w('Estoque de origem não pode ser o mesmo de destino!', 'Informação!');
                                    $('#cbestoquedestinoedicao').focus();
                                    return;
                                }                
                                if (parseInt(vself.vfracionadoedicao) === 0){
                                    if (!Number.isInteger(vself.vqtditemedicao)){
                                        vself.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
                                        $('#edqtditemedicao').focus();
                                        return;
                                    }
                                }
                                let indiceitem = util.getArrayIndexForKey(vself.lstitenstransf, 'idproduto', vself.vidprodutoedicao);
                                vself.vitem++;
                                let itemtmp = {
                                    idproduto		    : vself.vidprodutoedicao,
                                    descproduto		    : vself.vdescricaoprodutoedicao,
                                    coddig			    : vself.vcoddigedicao,
                                    item			    : vself.vitem,
                                    qtditem			    : vself.vqtditemedicao,
                                    unditem			    : vself.vundprodutoedicao,
                                    idestoqueorigem	    : vself.videstoqueorigemedicao,
                                    descestoqueorigem   : $('#cbestoqueorigemedicao').select2('data')[0]['text'],
                                    idestoquedestino    : vself.videstoquedestinoedicao,
                                    descestoquedestino  : $('#cbestoquedestinoedicao').select2('data')[0]['text'],
                                    prcusto             : parseFloat(vself.prcustoedicao),
                                    vlunitario          : parseFloat(vself.vlunitarioedicao),
                                    totalcusto          : parseFloat(vself.prcustoedicao) * parseFloat(vself.vqtditemedicao),
                                    totalvenda          : parseFloat(vself.vlunitarioedicao) * parseFloat(vself.vqtditemedicao)
                                }; 
                                
                                if (indiceitem !== -1){
                                    itemtmp.item = indiceitem;                                   
                                    vself.mtdalterarqtd(itemtmp, true, itemtmp.qtditem);								
                                }else{
                                    vself.mtdlancaitem(itemtmp);
                                }
                                vself.$nextTick(function () {
                                    vself.mtdlimparedicaoitem()
                                    $('#edidprodutoedicao').focus();
                                });
                            }else{
                                vself.$nextTick(function () {
                                    $('#edqtditemedicao').focus();
                                });
                            }
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
							vself.mtdlimparedicaoitem();
							$('#edidprodutoedicao').focus();
						}
					}).catch(function (response) {
						loader.hide();
					});
				}else{
					this.mtdlimparedicaoitem();
				}
            },            
            mtdselect2_def(){
                let vself = this;
				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
                let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';                

				$("#cbfilialorigempesq").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.pidfilialorigem = $("#cbfilialorigempesq").val();  
                    vself.mtdlimpar_listagem();
                });

				$("#cbfilialdestinopesq").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb	: 'tbfiliais',
								c1	: 'codfil',
								c2	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.pidfilialdestino = $("#cbfilialdestinopesq").val();
                    vself.mtdlimpar_listagem();
				});

				$("#cbfilialorigem").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidfilialorigem = $("#cbfilialorigem").val();  
                    vself.mtdcarregaestoquepadraofilial(vself.vidfilialorigem, '#cbestoqueorigemedicao', vself);
                });

				$("#cbfilialdestino").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb	: 'tbfiliais',
								c1	: 'codfil',
								c2	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidfilialdestino = $("#cbfilialdestino").val();
                    vself.mtdcarregaestoquepadraofilial(vself.vidfilialdestino, '#cbestoquedestinoedicao', vself);
				});                

				$("#cbestoqueorigemedicao").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.videstoqueorigemedicao = $("#cbestoqueorigemedicao").val();
				});
            
				$("#cbestoquedestinoedicao").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.videstoquedestinoedicao = $("#cbestoquedestinoedicao").val();
				});            

				$("#cbestoquealterar").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.videstoquealterar = $("#cbestoquealterar").val();
				}); 

				$("#cbclientenf").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbclientes',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 2,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.idclientenf = $("#cbclientenf").val();
				});                
            
                $('#mdalterarestoque').on('shown.bs.modal', function (e) {                   
                    vself.vatribuirestoque    = 0;
                    vself.videstoquealterar   = null;
                    $('#cbestoquealterar').val(null).trigger('change');                    
					$('#cbatribuir').focus();
                });  
                
                $('#mdinformacliente').on('shown.bs.modal', function (e) {                   
                    $('#cbclientenf').val(null).trigger('change');                    
					$('#cbclientenf').select2('open');
                });                
            },
            mtdfiltropesquisa(){
                let rfiltro = '';
                rfiltro     = this.pconteudo === '' ? '' : ' and t.id='+this.pconteudo;

				if(this.pidfilialorigem !== null){
					rfiltro = rfiltro + ' and t.idfilialorigem=' + this.pidfilialorigem;
				}

				if(this.pidfilialdestino !== null){
					rfiltro = rfiltro + ' and t.idfilialdestino=' + this.pidfilialdestino;
                }
                
				if(parseInt(this.psttransferencia) < 2){
					rfiltro = rfiltro + ' and t.sttransferencia='+this.psttransferencia;
				}

				if(parseInt(this.pfiltroperiodo) === 1){
					rfiltro = rfiltro + ' and t.dtemissao between "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
				}
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
				if (vself.pidfilialorigem === null && parseInt(vself.utodasfiliais) === 0){
					vself.$toastr.i('Seu usuário deve informar a filial para realização da consulta!', 'Informação!');
					return;
				}                
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtransferenciasfiliais.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregatransferencias(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregatransferencias(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtransferenciasfiliais.php');
                retorno.then(function (response) {
                    vself.lsttransferencias = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lsttransferencias = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();            
                this.vid                = '';                
                this.vitem              = 0;
                this.vidfilialorigem    = null;
                this.vidfilialdestino   = null;
                this.vdtemissao         = util.DataAtual(true, false);
                this.vobservacoes       = '';
                this.vtotalvenda        = 0;
                this.vtotalvenda        = 0;
                this.lstitenstransf     = [];
                this.$refs.reflstitens.selected_items = [];
                this.lancarauto         = false;

                this.vidprodutoedicao          = '';
                this.vdescricaoprodutoedicao   = '';
                this.vcoddigedicao             = '';
                this.vqtditemedicao            = 1;                

				if (parseInt(this.opcrud) === 1){
					var deffilialorigem = new Option(this.$store.state.filialpadrao.fantasia, this.$store.state.filialpadrao.codfil, true, true);
                    $('#cbfilialorigem').append(deffilialorigem).trigger('change');                                    
                    this.mtdcarregaestoquepadraofilial(this.$store.state.filialpadrao.codfil, '#cbestoqueorigemedicao', this);
                }                
                $("#cbfilialdestino").val(null).trigger('change');
            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#cbfilialorigem').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvitens"]').tab('show');
                vself.mtddefault();
            },            
            mtdnovo(){
                if (!util.opcaousuario('010Z.020Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE TRANSFERÊNCIA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);                        
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lsttransferencias = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;

                for (var i = 0; i < vself.lstitenstransf.length; i++) {
                    if (parseInt(vself.lstitenstransf[i].idestoqueorigem) === parseInt(vself.lstitenstransf[i].idestoquedestino)){
                        vself.$toastr.w('Alguns itens estão com o mesmo estoque de origem e destino! Verifique e tente novamente.', 'Atenção!');
                        return;                        
                    }
                }                               
                //Liberei pra no caso do usuáio querer apenas fazer transferências de um estoque para outro
                // if (vself.vidfilialorigem === vself.vidfilialdestino){                    
                //     vself.$toastr.w('Filial de origem não pode ser a mesma de destino!', 'Informação!');
                //     $('#cbfilialorigem').focus();
                //     return;
                // }                

                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtransferenciasfiliais.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(response.data[0].sttransferencia) === 1 ){
                        vself.$toastr.i('Transferência já efetivada, impossível realizar esta operação!', 'Informação!');
                        vself.mtdcancelaredicao();
                        return;
                    }                    
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('010Z.020Z.020Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    if (parseInt(item.sttransferencia) === 1 ){
                        this.$toastr.i('Transferência já efetivada, impossível realizar esta operação!', 'Informação!');
                        return;
                    }                        
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE TRANSFERÊNCIA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('010Z.020Z.030Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    if (parseInt(item.sttransferencia) === 1 ){
                        this.$toastr.i('Transferência já efetivada, impossível realizar esta operação!', 'Informação!');
                        return;
                    }                          
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE TRANSFERÊNCIA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdigualarcampos(registro){
                this.vid                 = registro.id;
                this.vdtemissao          = registro.dtemissao;
                this.vobservacoes        = registro.observacoes;
                this.vtotalcusto         = registro.totalcusto;
                this.vtotalvenda         = registro.totalvenda;                
                this.lstitenstransf      = registro.itens;

                this.vitem               = this.lstitenstransf[this.lstitenstransf.length - 1].item;

                var deffilialorigem = new Option(registro.fantasiafilialorigem, registro.idfilialorigem, true, true);
                $('#cbfilialorigem').append(deffilialorigem).trigger('change');                                                    

                var deffilialdestino = new Option(registro.fantasiafilialdestino, registro.idfilialdestino, true, true);
                $('#cbfilialdestino').append(deffilialdestino).trigger('change');                                                                    

            },
            mtdregistro(){
                let vself        = this;
                let loader = vself.$loading.show();
                let hora   	= util.DataAtual(true, true);
				hora 		= hora.substring(11, 19);
                let registrocrud = {
                    'id'                : this.vid,
                    'idfilialorigem'    : this.vidfilialorigem,
                    'idfilialdestino'   : this.vidfilialdestino,
                    'dtemissao'         : this.vdtemissao+' '+hora,
                    'observacoes'       : this.vobservacoes,
                    'totalcusto'        : this.vtotalcusto,
                    'totalvenda'        : this.vtotalvenda,
                    'itens'             : this.lstitenstransf
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '010Z.030Z.010Z' : parseInt(this.opcrud) === 2 ? '010Z.030Z.020Z' : '010Z.030Z.030Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtransferenciasfiliais.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.psttransferencia  = 2;
                        vself.pconteudo         = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas      = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregatransferencias(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdincluiritem(){
                let vself = this;
                if (vself.vidfilialorigem === null){                    
                    vself.$toastr.w('Filial de origem deve ser informada!', 'Informação!');
                    $('#cbfilialorigem').focus();
                    return;
                }
                if (vself.vidfilialdestino === null){                    
                    vself.$toastr.w('Filial de destino deve ser informada!', 'Informação!');
                    $('#cbfilialdestino').focus();
                    return;
                }                
                if (vself.vcoddigedicao === ''){                    
                    vself.$toastr.w('Código do produto deve ser informado!', 'Informação!');
                    $('#edidprodutoedicao').focus();
                    return;
                }
                if (vself.vdescricaoprodutoedicao === ''){                    
                    vself.$toastr.w('Descrição do produto deve ser informada!', 'Informação!');
                    vself.mtdhabilitaedicaodescpro();
                    return;
                }                                
                if (parseFloat(vself.vqtditemedicao) <= 0){                    
                    vself.$toastr.w('Quantidade inválida!', 'Informação!');
                    $('#edqtditemedicao').focus();
                    return;
                }                
                if (vself.videstoqueorigemedicao === null){                    
                    vself.$toastr.w('Estoque de origem deve ser informado!', 'Informação!');
                    $('#cbestoqueorigemedicao').focus();
                    return;
                }
                if (vself.videstoquedestinoedicao === null){                    
                    vself.$toastr.w('Estoque de destino deve ser informado!', 'Informação!');
                    $('#cbestoquedestinoedicao').focus();
                    return;
                }
                if (vself.videstoqueorigemedicao === vself.videstoquedestinoedicao){                    
                    vself.$toastr.w('Estoque de origem não pode ser o mesmo de destino!', 'Informação!');
                    $('#cbestoquedestinoedicao').focus();
                    return;
                }                
                if (parseInt(vself.vfracionadoedicao) === 0){
                    if (!Number.isInteger(vself.vqtditemedicao)){
						vself.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
						$('#edqtditemedicao').focus();
                        return;
                    }
                }
                let indiceitem = util.getArrayIndexForKey(vself.lstitenstransf, 'idproduto', vself.vidprodutoedicao);
                vself.vitem++;
                let itemtmp = {
                    idproduto		    : vself.vidprodutoedicao,
                    descproduto		    : vself.vdescricaoprodutoedicao,
                    coddig			    : vself.vcoddigedicao,
                    item			    : vself.vitem,
                    qtditem			    : vself.vqtditemedicao,
                    unditem			    : vself.vundprodutoedicao,
                    idestoqueorigem	    : vself.videstoqueorigemedicao,
                    descestoqueorigem   : $('#cbestoqueorigemedicao').select2('data')[0]['text'],
                    idestoquedestino    : vself.videstoquedestinoedicao,
                    descestoquedestino  : $('#cbestoquedestinoedicao').select2('data')[0]['text'],
                    prcusto             : parseFloat(vself.prcustoedicao),
                    vlunitario          : parseFloat(vself.vlunitarioedicao),
                    totalcusto          : parseFloat(vself.prcustoedicao) * parseFloat(vself.vqtditemedicao),
                    totalvenda          : parseFloat(vself.vlunitarioedicao) * parseFloat(vself.vqtditemedicao)
                };                
                if (indiceitem !== -1){
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Produto já lançado na transferência. Deseja adicionar a quantidade?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true); 
                                    itemtmp.item = indiceitem;                                   
                                    vself.mtdalterarqtd(itemtmp, true, itemtmp.qtditem);

                                    vself.vidprodutoedicao          = '';
                                    vself.vdescricaoprodutoedicao   = '';
                                    vself.vcoddigedicao             = '';
                                    vself.vqtditemedicao            = 1;
                                    setTimeout(() => {
                                        $('#edidprodutoedicao').focus();                                                                                                                      
                                    }, 500);                                  
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {                                
                                    vself.vidprodutoedicao          = '';
                                    vself.vdescricaoprodutoedicao   = '';
                                    vself.vcoddigedicao             = '';
                                    vself.vqtditemedicao            = 1;                                             
                                    setTimeout(() => {
                                        $('#edidprodutoedicao').focus();                                                                                                                      
                                    }, 500);
                                    
                                }
                            }
                        }
                    });                    
                }else{
                    vself.mtdlancaitem(itemtmp);
                }                
            },
            mtdlancaitem(itemtmp){
                let vself = this;
                vself.lstitenstransf.push(itemtmp);    

                vself.vtotalcusto = vself.vtotalcusto + parseFloat(itemtmp.totalcusto);    
                vself.vtotalvenda = vself.vtotalvenda + parseFloat(itemtmp.totalvenda);
                vself.mtdlimparedicaoitem();
                $('#edidprodutoedicao').focus();                
            },
            mtdexcluiritem(item){
                let indiceitem 		= util.getArrayIndexForKey(this.lstitenstransf, 'item', item.item);

                this.vtotalcusto = this.vtotalcusto - parseFloat(this.lstitenstransf[indiceitem].totalcusto);    
                this.vtotalvenda = this.vtotalvenda - parseFloat(this.lstitenstransf[indiceitem].totalvenda);

                this.lstitenstransf.splice(indiceitem, 1);                
            },
            mtdalterarqtd(item, aumentar, qtd){
                if (parseInt(this.opcrud) < 3){
                    let indiceitem 		= util.getArrayIndexForKey(this.lstitenstransf, 'idproduto', item.idproduto);                
                    if (aumentar) {
                        this.vtotalcusto = this.vtotalcusto + parseFloat(this.lstitenstransf[indiceitem].prcusto);    
                        this.vtotalvenda = this.vtotalvenda + parseFloat(this.lstitenstransf[indiceitem].vlunitario);                                      
                        this.lstitenstransf[indiceitem].qtditem+=qtd;
                    }else{
                        if (parseFloat(this.lstitenstransf[indiceitem].qtditem) > 1){
                            this.vtotalcusto = this.vtotalcusto - parseFloat(this.lstitenstransf[indiceitem].prcusto);    
                            this.vtotalvenda = this.vtotalvenda - parseFloat(this.lstitenstransf[indiceitem].vlunitario);                                      
                            this.lstitenstransf[indiceitem].qtditem-=qtd;
                        }else{
                            return;
                        }
                    }    
                    this.lstitenstransf[indiceitem].totalcusto = parseFloat(this.lstitenstransf[indiceitem].prcusto) * parseFloat(this.lstitenstransf[indiceitem].qtditem);
                    this.lstitenstransf[indiceitem].totalvenda = parseFloat(this.lstitenstransf[indiceitem].vlunitario) * parseFloat(this.lstitenstransf[indiceitem].qtditem);                                   
                }
            },
            mtdefetivar(transferencia){
                var vself       = this;
                if (!util.opcaousuario('010Z.020Z.040Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {                
                    if (parseInt(transferencia.sttransferencia) === 1){
                        vself.$toastr.w('Transferência já EFETIVADA no sistema!', 'Atenção!');
                        return;
                    }                    
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Esse processo é irreversível. Deseja mesmo realizar a EFETIVAÇÃO da transferência?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true);

                                    let loader      = vself.$loading.show();
                                    let parametros  = [
                                        {parametro: 'op',               valor : 'efetivar'},
                                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'idtransferencia',  valor : transferencia.id},
                                        {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                                        {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                                        {parametro: 'codop',            valor : '010Z.020Z.040Z'},
                                        {parametro: 'efetivarsemsaldo', valor : util.opcaousuario('010Z.020Z.050Z', vself.$store.state.perfilusuario) === false ? 0 : 1}
                                    ];
                                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtransferenciasfiliais.php');
                                    retorno.then(function (response) {
                                        loader.hide();
                                        if ($.isNumeric(response.data)){
                                            vself.$toastr.s('Transferência EFETIVADA com sucesso!', 'Informação!');
                                            vself.psttransferencia  = 2;
                                            vself.pconteudo         = transferencia.id;
                                            vself.pqtd_paginas      = 1;
                                            vself.mtdcarregatransferencias(1);
                                        }else{
                                            let tpret = response.data.substring(0,1);
                                            switch (tpret) {
                                                case 'I':
                                                    vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                    break;
                                                case 'E': default:
                                                    vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                    break;
                                            }
                                        }
                                    }).catch(function (response) {
                                        loader.hide();
                                        vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                    });
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                }
                            }
                        }
                    });
                }    
            },

            //Luiz Trindade - Adiconar o parâmetro de URL de custo de itens
			mtdimprimirtransferencia(idtransferencia){				
				window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirtransferencia.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idtransferencia='+idtransferencia+
                            '&idu='+this.$store.state.usuario.id+
                            '&custoitens='+this.vcustoitens
                            , '_blank');				
			},

            mtdrotinaestoque(){
                if (this.$refs.reflstitens.selected_items.length === 0){
                    this.$toastr.w('Selecione os itens para a alteração do estoque!', 'Atenção!');
                    return;
                } 
                $('#mdalterarestoque').modal('show');                                               
            },
            mtdatribuirestoque(){
                if (this.videstoquealterar === null){
                    this.$toastr.w('Selecione o estoque para a alteração!', 'Atenção!');
                    $('#cbestoquealterar').select2('open');
                    return;
                }
                for (var i = 0; i < this.$refs.reflstitens.selected_items.length; i++) {
                    let idit = util.getArrayIndexForKey(this.lstitenstransf, 'idproduto', this.$refs.reflstitens.selected_items[i]['idproduto']);
                    if (parseInt(this.vatribuirestoque) === 0){
                        this.lstitenstransf[idit].idestoqueorigem       = this.videstoquealterar;
                        this.lstitenstransf[idit].descestoqueorigem     = $('#cbestoquealterar').select2('data')[0]['text'];
                    }else{
                        this.lstitenstransf[idit].idestoquedestino      = this.videstoquealterar;
                        this.lstitenstransf[idit].descestoquedestino    = $('#cbestoquealterar').select2('data')[0]['text'];
                    }                    
                }
                this.$refs.reflstitens.selected_items = [];                
                $('#mdalterarestoque').modal('hide');                  
            },
            mtrotinanf(transferencia){
				$('#mdmenutransf').modal('hide');
				if (!util.opcaousuario('010Z.020Z.060Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else{                
                    if (parseInt(transferencia.sttransferencia) === 0 ){
                        this.$toastr.i('Para gerar a NF-e a transferência deve ser efetivada!', 'Informação!');
                        return;
                    }
                    this.transferencianf = transferencia;
                    this.idclientenf     = null;
                    $('#cbclientenf').val(null).trigger('change'); 
                    $('#mdinformacliente').modal('show');
                }
            },
			mtdgerarnf(){
                let vself  = this;
                if (vself.idclientenf === null ){
                    vself.$toastr.i('Cliente deve ser informado!', 'Informação!');
                    return;
                }                
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'op',           valor : 'gerarnf'},
                    {parametro: 'transferencia',valor : JSON.stringify(vself.transferencianf)},
                    {parametro: 'idcliente',    valor : vself.idclientenf},
                    {parametro: 'nomecliente',  valor : $('#cbclientenf').select2('data')[0]['text']},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '010Z.020Z.060Z'}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtransferenciasfiliais.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Nota gerada com sucesso!', 'Informação!');
                        $('#mdinformacliente').modal('hide');
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });				
			}        
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                vself.utodasfiliais = vself.$store.state.usuario.todasfiliais;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (parseInt(vself.$store.state.filialpadrao.plnc) < 2){
                        vself.$swal.fire({
                                            position: 'bottom-end',
                                            //icon: 'success',
                                            title: 'Atenção!',
                                            html: 'Seu plano não contempla esta funcionalidade! Favor entrar em contato com a <strong>Rillsoft Sistemas</strong> para mais informações.',
                                            showConfirmButton: false,
                                            showCloseButton: true,
                                            backdrop: false                                                
                                        }); 
                        setTimeout(function(){
                            util.gotoprincipal();
                        },4000);                                                               
                    }                    
                    if (util.opcaousuario('010Z.020Z', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtdselect2_def();
                        vself.mtdexecutapesquisa();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                return this.vdtemissao === '' || this.lstitenstransf.length === 0;
            },
            idprodutoretorno(){
                return this.$store.state.produtoretornoconsulta.idproduto;
            },
            selecionaperiodo() {
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
            }            
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregatransferencias(val);
            },
            idprodutoretorno(val){
                if (val !== null || val !== ''){
					this.vcoddigedicao = val;
					this.mtdlocalizarproduto(this.vcoddigedicao);					
                }
			}
        }
    }
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }
    .def-col-opcoes-item{
        width: 40px !important;
    }
    .def-col-qtd-item{
        width: 100px!important;
    }
    .def-col-sttransferencia{
        width: 100px !important;
    }
    .op-qtd{        
        cursor: pointer;
        font-size: 20px!important;
        padding-left: 5px;
        padding-right: 5px;
    }
    .op-qtd-ret{ 
        float: left;
        color: #f82b54!important;       
    }   
    .op-qtd-acres{ 
        float: right;       
        color: #0acf97!important;       
    }
    .op-qtd:hover{
        filter: brightness(90%)!important;
    }             
</style>